export {LockIcon} from './lock_icon';
